
export const resetDataChanges = (originData = {}, defaultObj = {}) => {
  const resetData = {};
  Object.keys(defaultObj).forEach((e) => {
    resetData[e] = originData[e] || '';
  });
  return resetData;
};



// WEBPACK FOOTER //
// ./src/utils/inputChanges.js